<template>
    <EnhancedImage :src="pdfIconUrl" height="24" width="24" />
</template>
<script setup lang="ts">
const config = useRuntimeConfig();
const cdnUrl = config.public.cdnUrl;
const pdfIconUrl = cdnUrl + "/assets/images/adobe-pdf-file-icon-24x24.png";
</script>
